import s from './home.module.css';
import { useModal } from '@/lib/ModalContext';

export default function Hero() {
  const { setOpen } = useModal();
  return (
    <section className={s.hero}>
      <div className="container">
        <div className={s.heroInner}>
          <div>
            <span className={s.heroEyebrow}><span className={s.dot} />Private beta &mdash; onboarding founding firms</span>
            <h1 className={s.heroTitle}>
              An attorney<br />
              when you need one.<br />
              <span className={s.accent}>ELARIA</span> <span className={s.gold}>when you don't.</span>
            </h1>
            <p className={s.heroSub}>
              AVOWAL is white-label infrastructure for independent attorneys. <em>ELARIA</em> &mdash; an AI
              legal operations engine &mdash; runs intake, drafting, deadlines, and client status under your
              firm&rsquo;s own brand. Flat software fee, never a share of legal fees. Clients pay their
              attorney directly. The attorney decides everything.
            </p>
            <div className={s.heroCtaRow}>
              <button className={`${s.btn} ${s.btnPrimary}`} onClick={() => setOpen('waitlist')}>For attorneys: request a walkthrough &rarr;</button>
              <button className={`${s.btn} ${s.btnSecondary}`} onClick={() => setOpen('intake')}>Preview the client experience</button>
            </div>
            <div className={s.heroMeta}>
              <span>Attorney-backed</span>
              <span>AI-managed</span>
              <span>Flat-fee transparency</span>
              <span>Web &middot; macOS &middot; iOS</span>
            </div>
          </div>
          <AgentCard />
        </div>
      </div>
    </section>
  );
}

function AgentCard() {
  return (
    <div>
      <div className={s.agentCard}>
        <div className={s.agentCardHead}>
          <span className={s.agentCardId}>Agent &middot; <strong>ELARIA</strong></span>
          <span className={s.agentStatus}><span className={s.dot} />Online</span>
        </div>
        <div className={s.agentLine}><span className="k">Class</span><span className="v">Legal Operations Agent</span></div>
        <div className={s.agentLine}><span className="k">Function</span><span className={`v ${s.vCyan}`}>Triage &middot; Draft &middot; Verify</span></div>
        <div className={s.agentLine}><span className="k">Attorneys</span><span className="v">Independent &middot; bar-admitted</span></div>
        <div className={s.agentLine}><span className="k">Citations</span><span className="v">Verified against primary sources</span></div>
        <div className={s.agentLine}><span className="k">Disclosure</span><span className={`v ${s.vGold}`}>Not legal advice</span></div>
        <div className={s.agentFoot}>
          &ldquo;I prepare your matter, surface the questions only an attorney can answer, and stay with the
          file 24/7. Your attorney handles judgment. I handle everything else.&rdquo;
        </div>
      </div>
    </div>
  );
}
